module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-main-media block-main-media-video"
  }, [(_vm.showLink) ? _c('a', {
    staticClass: "video-play-button",
    attrs: {
      "href": _vm.imageLink
    }
  }, [_c('top-image-box-content', {
    attrs: {
      "is-active": true,
      "isCanceled": _vm.canceledHearing,
      "isPostponed": _vm.postponedHearing
    }
  })], 1) : _c('div', {
    staticClass: "no-link"
  }, [_c('top-image-box-content', {
    attrs: {
      "is-active": false,
      "isCanceled": _vm.canceledHearing,
      "isPostponed": _vm.postponedHearing
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63bfcbe6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Top/TopImageBox.vue
// module id = 100
// module chunks = 1